// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"Card_singleCard__1nsRx","cardFig":"Card_cardFig__3v2rz","heading":"Card_heading__3rRF-","description":"Card_description__2Iuuk"};